module.exports = __webpack_public_path__ + "static/media/java.a732a6e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/java.svg
// module id = 529
// module chunks = 0